export default "__VITE_ASSET__DdFtPqpd__"